import React, { useState } from "react";
import { userAPI } from "../../services/api";
import { toast } from "react-toastify";
import { FiRefreshCw, FiAlertTriangle } from "react-icons/fi";

export default function AccountDeactivated() {
  const [loading, setLoading] = useState(false);

  const reactivate = async () => {
    setLoading(true);
    try {
      await userAPI.reactivateAccount();
      toast.success("Namaste! Your account has been reactivated successfully.");
      setTimeout(() => {
        window.location.href = "/user/dashboard";
      }, 1000);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to reactivate account. Please try again or contact support.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 bg-[#FFF8EE] font-sans">
      <div className="max-w-md w-full p-8 rounded-[32px] bg-white/95 border border-[#F4D9B5] shadow-[0_20px_60px_rgba(0,0,0,0.06)] backdrop-blur-2xl text-center">
        <div className="w-16 h-16 rounded-2xl bg-[#FEF3C7] border border-amber-200 flex items-center justify-center text-amber-700 mx-auto mb-5 shadow-sm">
          <FiAlertTriangle size={28} />
        </div>

        <h1 className="text-2xl sm:text-3xl font-extrabold text-[#111111] mb-2 tracking-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
          Account Deactivated
        </h1>

        <p className="text-xs sm:text-sm text-[#666666] leading-relaxed mb-6 font-medium">
          Your account is currently paused. You can instantly reactivate your account and resume your sacred yoga practice at any time.
        </p>

        <button
          type="button"
          disabled={loading}
          onClick={reactivate}
          className="w-full py-3.5 rounded-full bg-gradient-to-r from-[#F29A0C] to-[#E97818] text-white font-bold text-xs uppercase tracking-wider shadow-[0_8px_24px_rgba(242,154,12,0.35)] hover:shadow-[0_12px_32px_rgba(242,154,12,0.5)] hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 flex items-center justify-center gap-2 cursor-pointer disabled:opacity-50"
        >
          {loading ? (
            <>
              <FiRefreshCw className="animate-spin" size={14} />
              <span>Reactivating Account...</span>
            </>
          ) : (
            <span>Reactivate Account</span>
          )}
        </button>
      </div>
    </div>
  );
}